module.exports = __webpack_public_path__ + "static/img/dyItem2.fff8782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dymanticLanshu/dyItem2.png
// module id = 9RI3
// module chunks = 0